import { useTypedSelector } from './useTypedSelector'
import type {
    CaseworkerOpenReportState,
    LoadedState,
} from '../state/reducers/caseworkerOpenReportReducer'

/**
 * Returns the full discriminated union state for the open report.
 * Consumers should narrow on `state.type` before accessing data.
 */
export const useOpenReportState = (): CaseworkerOpenReportState =>
    useTypedSelector((state) => state.caseworkerOpenReport)

/**
 * Returns the loaded open report state.
 * Only call this in components that are guaranteed to render
 * inside a `state.type === 'loaded'` guard (e.g. child components
 * of SingleCase that only mount after loading completes).
 * Throws if called before the report is loaded.
 */
export const useLoadedOpenReport = (): LoadedState => {
    const state = useOpenReportState()
    if (state.type !== 'loaded') {
        throw new Error(
            'useLoadedOpenReport() called before report was loaded. ' +
            'This hook should only be used in components rendered inside a loaded guard.'
        )
    }
    return state
}
